var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrainIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-brain w-4 h-4 text-primary",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.599 6.5a3 3 0 0 0 .399-1.375"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.003 5.125A3 3 0 0 0 6.401 6.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.477 10.896a4 4 0 0 1 .585-.396"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.938 10.5a4 4 0 0 1 .585.396"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18a4 4 0 0 1-1.967-.516"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.967 17.484A4 4 0 0 1 18 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainIcon);
export default __webpack_public_path__ + "static/media/brain-icon.364461bf71b90e64a7801f5d99d14cf7.svg";
export { ForwardRef as ReactComponent };